import { createContext } from 'react';

const ViewportContext = createContext({
  frameWidth: 0,
  frameHeight: 0,
});

export default ViewportContext;
